
export const fileNameSafeString = (str: string) => str.replace(/[/\\?%*:|"<>]/g, '-');

export const fileNameSafeStringLong = (str: string) => str
	.replaceAll('\\', '‖')
	.replaceAll('/', '|')
	.replaceAll('.', '(dot)')
	.replaceAll('!', '(bang)')
	.replaceAll('~', 'tilde')
	.replaceAll('*', '(star)')
	.replaceAll('<', '(lt)')
	.replaceAll('>', '(gt)')
	.replaceAll('"', '(dq)')
	.replaceAll("'", '(quote)')